import { selectCurrentHotelName } from 'accessors'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import SiteAbandonmentIcon from 'components/ReusableComponents/Icons/SiteAbandonment'
import { useSelector } from 'react-redux'

import styles from './LockedSiteAbandonment.module.scss'

const SparkleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
      fill="currentColor"
    />
    <path
      d="M19 14L19.8 17.2L23 18L19.8 18.8L19 22L18.2 18.8L15 18L18.2 17.2L19 14Z"
      fill="currentColor"
      opacity="0.7"
    />
  </svg>
)

const ChatBubbleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 4H20C21.1 4 22 4.9 22 6V16C22 17.1 21.1 18 20 18H7L3 22V6C3 4.9 3.9 4 4 4Z"
      fill="currentColor"
    />
  </svg>
)

const FEATURES = [
  {
    title: 'Recover abandoned bookings',
    description:
      'Reach guests who started but never completed a reservation with timed messages.'
  },
  {
    title: 'Email + SMS sequences',
    description:
      'Build multi-step campaigns that engage guests on the channels they actually use.'
  },
  {
    title: 'Onsite widgets & promos',
    description:
      'Show contextual offers on your booking site to grow direct revenue.'
  }
]

const LockedSiteAbandonment = () => {
  const hotelName = useSelector(selectCurrentHotelName)

  function openChat() {
    const message = `I would like to enable Site abandonment for ${hotelName ?? 'my hotel'}.`
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:open'])
      window.$crisp.push(['set', 'message:text', [message]])
    }
  }

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Site abandonment" width={900} />
      <div className={styles.card}>
        <div className={styles.iconHolder}>
          <SiteAbandonmentIcon />
        </div>
        <p className={styles.eyebrow}>Engage+ feature</p>
        <h2 className={styles.title}>Turn site visitors into paying guests</h2>
        <p className={styles.description}>
          Site abandonment is included in Engage+. Unlock it to recover lost bookings
          with smart widgets, follow-up campaigns, and personalized offers across email
          and text.
        </p>

        <div className={styles.featureGrid}>
          {FEATURES.map(feature => (
            <div key={feature.title} className={styles.feature}>
              <p className={styles.featureTitle}>
                <SparkleIcon />
                {feature.title}
              </p>
              <p className={styles.featureText}>{feature.description}</p>
            </div>
          ))}
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.chatButton} onClick={openChat}>
            <ChatBubbleIcon />
            Talk to us to unlock
          </button>
        </div>
        <p className={styles.footnote}>
          Our team will help you get set up in minutes - no commitment required.
        </p>
      </div>
    </div>
  )
}

export default LockedSiteAbandonment
